import {Map, List, fromJS} from 'immutable';
import moment from 'moment';
import 'moment-timezone';

import * as action from '../actions';

const initialState = Map({
	date: null,
	bookings: Map({
		loading: true,
		list: List([]),
	}),
	my_bookings: Map({
		loading: true,
		list: List([]),
		appleWalletLink: null,
		isAppleWalletAdded: false,
	}),
	tables: Map({
		loading: true,
		list: List([]),
	}),
	intervals: List([]),
	selected: Map({
		table_id: null,
		intervals: List([]),
	}),
	form: Map({
		loading: false,
		data: Map({}),
	}),
	swipe: true,
});

const actionHandlers = {
	// Сохранение формы
	[action.book.request]: (state, {form}) => {
		return state
			.setIn(['form', 'loading'], true)
			.setIn(['form', 'data'], Map(form));
	},
	[action.book.success]: state => {
		return state
			.setIn(['form', 'loading'], false)
			.setIn(['form', 'data'], Map({}))
			.setIn(['selected'], initialState.get('selected'));
	},
	[action.book.failure]: state => {
		return state
			.setIn(['form', 'loading'], false);
	},

	// список броней
	[action.loadBookings.request]: state => {
		return state
			.setIn(['bookings','loading'], true);
	},
	[action.loadBookings.success]: (state, {list}) => {
		let items = list.reduce((items, booking) => {
			items.push({
				table_id: booking.table_id,
				from: moment(booking.booked_from, 'YYYY-MM-DD HH:mm:ss').toDate(),
				till: moment(booking.booked_till, 'YYYY-MM-DD HH:mm:ss').toDate(),
			});
			return items;
		}, []);

		return state
			.setIn(['bookings','loading'], false)
			.setIn(['bookings','list'], fromJS(items));
	},
	[action.loadBookings.failure]: state => {
		return state
			.setIn(['bookings','loading'], false);
	},

	// список моих броней
	[action.loadMyBookings.request]: state => {
		return state
			.setIn(['my_bookings','loading'], true);
	},
	[action.loadMyBookings.success]: (state, {list}) => {
		let items = list.reduce((items, booking, index) => {
			if (!index && booking.appleWalletLink) {
				state = state
					.setIn(['my_bookings','appleWalletLink'], booking.appleWalletLink)
					.setIn(['my_bookings','isAppleWalletAdded'], booking.isAppleWalletAdded);
			}
			items.push({
				id: booking.id,
				table_id: booking.table_id,
				from: moment(booking.booked_from, 'YYYY-MM-DD HH:mm:ss').toDate(),
				till: moment(booking.booked_till, 'YYYY-MM-DD HH:mm:ss').toDate(),
			});
			return items;
		}, []);

		return state
			.setIn(['my_bookings','loading'], false)
			.setIn(['my_bookings','list'], fromJS(items));
	},
	[action.loadMyBookings.failure]: state => {
		return state
			.setIn(['my_bookings','loading'], false);
	},

	// список столов
	[action.loadTables.request]: state => {
		return state.setIn(['tables','loading'], true);
	},
	[action.loadTables.success]: (state, {list}) => {
		return state
			.setIn(['tables','loading'], false)
			.setIn(['tables','list'], fromJS(list));
	},
	[action.loadTables.failure]: state => {
		return state.setIn(['tables','loading'], false);
	},

	// интервалы
	[action.calcIntervals]: (state, {date, settings}) => {
		const {open, close, interval, timezone, midnight} = settings;
		let intervals = [];
		let current;
		const today = moment.tz(timezone).subtract({hours: Number(midnight)}).format('YYYY-MM-DD');
		const weekdayNum = moment(date, 'YYYY-MM-DD').format('E');
		const _open = Number(settings['open_' + weekdayNum] || open);
		const _close = Number(settings['close_' + weekdayNum] || close);
		if (date === today) {
			current = moment.tz(timezone).format('H');
			current++;
			if (Number(midnight) - current >= 0) {
				current = current + 24;
			}
			if (_open - current > 0) {
				current = _open;
			}
		} else {
			current = _open;
		}
		console.log(current);
		if (_close > current) {
			let i_max = Math.floor((_close-current)*60/interval);
			for (let i=0; i<i_max; i++) {
				intervals.push(
					moment(date, 'YYYY-MM-DD').startOf('day').add({
						hours: current,
						minutes: interval*i,
					}).toDate()
				);
			}
		}

		return state.setIn(['intervals'], fromJS(intervals))
			.setIn(['date'], date);
	},
	[action.selectIntervals]: (state, {table_id, intervals, group_id}) => {
		const prev_table_id = state.getIn(['selected', 'table_id'], []);
		let newIntervals = state.getIn(['selected', 'intervals']).toJS();
		if (table_id !== prev_table_id) {
			newIntervals = [];
		}
		intervals.forEach(date => newIntervals.push({date, group_id}));
		newIntervals.sort((a, b) => (a.date - b.date));
		markFirstLastIntervals(newIntervals);

		return state
			.setIn(['selected', 'table_id'], table_id)
			.setIn(['selected', 'intervals'], fromJS(newIntervals));
	},
	[action.unselectIntervals]: (state, {group_id}) => {
		const newIntervals = state.getIn(['selected', 'intervals'])
			.toJS()
			.filter(interval => interval.group_id !== group_id);

		if (newIntervals.length) {
			markFirstLastIntervals(newIntervals);
		} else {
			state = state.setIn(['selected', 'table_id'], null);
		}

		return state
			.setIn(['selected', 'intervals'], fromJS(newIntervals));
	},
	[action.unselectAll]: state => {
		return state
			.setIn(['selected'], initialState.get('selected'));
	},

	[action.swipeIsShown]: state => {
		return state.merge({swipe: false});
	},
};

function markFirstLastIntervals(newIntervals) {
	const firstGroupId = newIntervals[0].group_id;
	const lastGroupId = newIntervals[newIntervals.length-1].group_id;
	newIntervals.forEach(function(interval, i) {
		newIntervals[i].first = interval.group_id === firstGroupId;
		newIntervals[i].last = interval.group_id === lastGroupId;
	});
}

export {initialState, actionHandlers};
export default createReducer => createReducer(initialState, actionHandlers);



// WEBPACK FOOTER //
// ./src/reducers/bookReducer.js